import { render, staticRenderFns } from "./ChatwootInbox.vue?vue&type=template&id=61034ef6&scoped=true"
import script from "./ChatwootInbox.vue?vue&type=script&lang=js"
export * from "./ChatwootInbox.vue?vue&type=script&lang=js"
import style0 from "./ChatwootInbox.vue?vue&type=style&index=0&id=61034ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61034ef6",
  null
  
)

export default component.exports